import {
	Map,
} from 'immutable';

import {
	CHANGE_URL_STATE,
	LOGOUT_SUCCESSFUL,
	STORE_LOADED_PAGES,
} from '~/actions';



function createDefaultState() {
	return new Map({
		inProgressLoading: false,
		show: true,
	});
}



export function dataLoading(state, action) {
	if (state === undefined) {
		state = createDefaultState();
	}

	switch (action.type) {

		case CHANGE_URL_STATE: {
			const {
				previousUrlState,
				urlState,
			} = action;

			if (
				urlState.params.websiteId !== previousUrlState.params.websiteId
				&& urlState.name === 'website.pages'
			) {
				state = state.set('show', true);
			}

			break;
		}

		case LOGOUT_SUCCESSFUL: {
			state = createDefaultState();

			break;
		}

		case STORE_LOADED_PAGES: {
			state = state.set('show', false);
			state = state.set('inProgressLoading', false);

			break;
		}

	}

	return state;
}
